import { Afip } from './interfaces/afip';

export class AfipModel implements Afip {
  public cuit: string;
  public razonSocial: string;
  public domicilioFiscal: string;
  public estadoClave: string;
  public tipoImpuesto: string;
  public actividad: string;
  public tipoPersona: string;

  constructor() {
    this.cuit = '';
    this.razonSocial = '';
    this.domicilioFiscal = '';
    this.estadoClave = '';
    this.tipoImpuesto = '';
    this.actividad = '';
    this.tipoPersona = '';
  }
}
